/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ITextProps, ITextStyles } from '@fluentui/react/lib/Text';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { LuisText } from 'src/core/components/LuisText';
import { getScopedTheme } from 'src/core/themes/luisStylist';

const theme = getScopedTheme('Badge');

export type BadgeProps = {
    text?: string;
    title?: string;
    className?: string;
};

const textStyles = classNamesFunction<ITextProps, ITextStyles>()({
    root: {
        textTransform: 'uppercase',
        fontSize: 10,
        marginLeft: 8,
        color: theme.textColor,
        letterSpacing: '1px'
    }
});

/**
 * Represents a badge with certain style.
 */
export const Badge = (props: BadgeProps) => {
    const { text, className } = props;

    return (
        <LuisText title={props.title} className={className} styles={textStyles}>
            {text}
        </LuisText>
    );
};
